export default __webpack_public_path__ + "static/media/symptop-right.fb3a8582.png";